






























































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import Paginition from './Paginition.vue';

@Component({
  components: {
    Paginition,
  },

  computed: {...mapGetters(['shipList'])},
})
export default class DashboardDataFooter extends Vue {
  @Prop() parentType!: String;
  @Prop({default: ''}) parentName!: String;

  @Prop() totalData!: number;
  @Prop({default: false}) noData!: boolean;

  @Prop() selectedShip: any;
  shipId = null;
  sevrityChartName = 'Bar';
  findingsChartName = 'Pie';

  mounted() {
    this.shipId = this.selectedShip;
  }

  monthId = 12;
  monthsData = [
    {id: 1, displayName: '3 Month', value: 3},
    {id: 2, displayName: '6 Months', value: 6},
    {id: 3, displayName: '9 Months', value: 9},
    {id: 4, displayName: '12 Months', value: 12},
    {id: 5, displayName: '18 Months', value: 18},
  ];

  chartTypes = [
    {id: 1, displayName: 'Pie', value: 'Pie'},
    {id: 2, displayName: 'Bar', value: 'Bar'},
    {id: 3, displayName: 'Column', value: 'Column'},
    {id: 4, displayName: 'Line', value: 'Line'},
    {id: 5, displayName: 'Radar', value: 'Radar'},
    {id: 6, displayName: 'Donut', value: 'Donut'},
    {id: 7, displayName: 'Area', value: 'Area'},
    {id: 8, displayName: 'Heatmap', value: 'Heatmap'},
  ];

  //get dynamic chart type based on module or inspection type
  geChartTypes() {
    if (this.parentName === 'findings') return this.chartTypes.filter((me) => me.value !== 'Heatmap');
  }
  // calling function in parent on month change
  onMonthChange() {
    let params = {
      months: this.monthId,
      shipId: this.shipId,
    };
    this.$emit('onMonthDurationChange', params);
  }
  // calling function in parent on ship change
  onShipChange() {
    this.$emit('onShipChange', this.shipId);
  }

  // calling function in parent on chart change
  onChartChange() {
    if (this.parentName === 'severity') this.$emit('onChartChange', this.sevrityChartName);
    else this.$emit('onChartChange', this.findingsChartName);
  }

  // calling function in parent on display
  onDisplayClick() {
    let params = {
      lastMonths: this.monthId,
      shipId: this.shipId,
    };
    this.$emit('onDisplayClick', params);
  }

  //render records based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.$emit('onPaginitionValueChange', startingPoint, endingPoint);
  }

  //navigate to inspection list page
  onViewAllClick() {
    if (this.parentName === 'mustsee') {
      this.$router.push('/inspection-list/severity/1');
    } else if (this.parentName === 'actionplan') {
      this.$router.push('/inspection/action-plan');
    } else {
      this.$router.push('/inspection-list');
    }
  }

  @Watch('selectedShip', {immediate: true})
  changeSelectedSHip(newV, oldV) {
    this.shipId = newV;
    this.$forceUpdate();
  }

  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination?.reset();
    }, 150);
  }

  @Watch('totalData', {immediate: true})
  total(newV, oldV) {
    if (newV !== oldV) {
      this.resetPagination();
    }
  }
}
